import projectsModel from '$$projectModel';
import multiViewsProjectsModel from '$$multiviewModel';
import userProjectConfigModel from '$$userProjectConfigModel';
import customDayTemplatesModel from '$$customDayTemplatesModel';
import sharedProjectsHelpers from './helpers';

export default {
  setData(state, { project, customDays }) {
    projectsModel.parse(sharedProjectsHelpers.prepareInitProjects(project));
    projectsModel.setActiveGanttId(project.gantt_id);

    userProjectConfigModel.initProjects(projectsModel.serialize());

    customDayTemplatesModel.parse([{
      ganttId: project.gantt_id,
      user_created: 0,
      customDays,
    }]);
  },

  setDataMultiview(state, payload) {
    const { projects, ...multiviewData } = payload;
    const preparedProjects = projects.map(sharedProjectsHelpers.prepareInitProjects);

    projectsModel.parse(preparedProjects);

    userProjectConfigModel.initProjects(projectsModel.serialize());

    multiViewsProjectsModel.parse(multiviewData);
    multiViewsProjectsModel.setActiveMultiView(multiviewData.id);

    // CUSTOM DAYS
    customDayTemplatesModel.parse(payload.multiviewCustomDays);
  },

};
